module.exports = __webpack_public_path__ + "static/media/47.c4e6acfc.png";